module.exports = __webpack_public_path__ + "static/media/CES Media Day Presentation-CES FINAL DEC 16_1639713000879.77b3c6df.vtt";